import { type HttpEvent, type HttpHandler, type HttpInterceptor, type HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigProperty, ConfigService } from '@sds/shared';
import { type Observable } from 'rxjs';

@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {
  private readonly configService = inject(ConfigService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const bypassUrls = new RegExp(`${this.configService.get(ConfigProperty.AdministrationApi)}/v\\d+/mercure/token`);
    if (bypassUrls.exec(req.url)) {
      const newReq = req.clone({
        setHeaders: {
          'ngsw-bypass': 'true'
        }
      });
      return next.handle(newReq);
    }
    return next.handle(req);
  }
}
